const { isEmptyObject } = require("jquery");

window.$ = window.jQuery = require("jquery");



$(document).ready(function () {
    $(".mobile-menu-bar .search").click(function (e) {
        e.preventDefault();
        $(".mm_search").fadeIn("fast");
        $(".mm_search").css("display", "flex");
        $(".mm_search").addClass("active");
    });
    // Gestion du formulaire de recherche
    $(".close-search-form").click(function () {
        $(".mm_search").fadeOut("fast");
    });

    $(".clear-search").click(function (e) {
        const ctx = $(this).closest(".search-form");
        $("input.search-text", ctx).val("");
    });
});
